module.exports = __webpack_public_path__ + "static/media/calendar-11015.b5756a22.svg";